import { render, staticRenderFns } from "./ProductsDialog.vue?vue&type=template&id=39b59f2c&scoped=true&"
import script from "./ProductsDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsDialog.vue?vue&type=style&index=0&id=39b59f2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b59f2c",
  null
  
)

export default component.exports